<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <warehouse-form v-if="orderEmailText !== null" @submit="submit" :init-warehouse="{ order_email_text: orderEmailText }"
          :val-errors="valErrors" submit-text="Erstellen" />
      </card>
    </div>
  </div>
</template>

<script>
import WarehouseForm from './warehouse-form'

export default {
  components: { WarehouseForm },
  data() {
    return {
      valErrors: [],
      orderEmailText: null
    }
  },
  methods: {
    async submit(supplier) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('warehouses', supplier).then(({ data }) => {
        this.$notify({
          message: 'Lager erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/warehouses')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
  },
  async created() {
    try {
      const { data } = await this.$http.get('/settings');

      if (data.order_email_warehouse_text) {
        this.orderEmailText = `${data.order_email_warehouse_text}`;
      } else {
        this.orderEmailText = ''
      }


    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  }
}
</script>

<style></style>
